import { Directive, inject } from "@angular/core";
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from "@angular/forms";
import { OrganizationService } from "@main/companies";

@Directive({
    selector: "patient-consent",
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: PatientConsentValidatorDirective,
            multi: true
        }
    ]
})
export class PatientConsentValidatorDirective implements AsyncValidator {
    private organizationService = inject(OrganizationService);
    private enabledPsdConfirmation: boolean;

    async validate(control: AbstractControl): Promise<ValidationErrors | null> {
        if (this.enabledPsdConfirmation == null) {
            this.enabledPsdConfirmation = await this.organizationService.getEnablePatientPsdConfirmation();
        }

        if (this.enabledPsdConfirmation && (control.value == null || control.value == false)) {
            return { required: true };
        }

        return null;
    }
}
